const TAX_EXCLUSIVE_COUNTRIES = ['US', 'CA'];

export const isCountryTaxExclusive = (priceCountryId?: string) => {
    if (priceCountryId) {
        return TAX_EXCLUSIVE_COUNTRIES.includes(priceCountryId);
    } else {
        return false;
    }
};
